import { useEffect, useMemo,useRef } from "react";
import { useLocation } from "react-router-dom";

import { IframeUrlTracker, type IframeUrlTrackerOptions } from "./iframe-url-tracker";

export type UseIframeUrlTrackingOptions = IframeUrlTrackerOptions;

export function useIframeUrlTracking(options: UseIframeUrlTrackingOptions = {}) {
  const location = useLocation();
  const trackerRef = useRef<IframeUrlTracker | null>(null);

  // Stabilize options to prevent unnecessary re-renders
  const stableOptions = useMemo(() => options, [options]);

  // Initialize tracker on mount
  useEffect(() => {
    trackerRef.current = new IframeUrlTracker(stableOptions);

    return () => {
      if (trackerRef.current) {
        trackerRef.current.destroy();
        trackerRef.current = null;
      }
    };
  }, [stableOptions]);

  // Update path when location changes (React Router navigation)
  useEffect(() => {
    if (trackerRef.current && location?.pathname) {
      trackerRef.current.updatePath(location.pathname);
    }
  }, [location?.pathname]);

  return {
    tracker: trackerRef.current,
    isInIframe: typeof window !== "undefined" && window.parent !== window,
  };
}
